// Cross-platform mount resolver for SELECTOR placement. APP_BLOCK / CUSTOM mounts
// already exist in the DOM (the entry renders straight into them); SELECTOR
// campaigns carry no element, so we create one next to a merchant CSS selector on
// any platform. Mirrors common/backinstock-utils setupPlacement / retryInsert but
// supports all four insert positions (BEFORE / AFTER / PREPEND / APPEND).

const MAX_PLACEMENT_INSERT_RETRIES = 10;

export function resolvePlacement(store) {
  if (!store.isSelectorPlacement) return null;
  let referenceNode;
  try {
    referenceNode = document.querySelector(store.placementCssSelector);
  } catch (e) {
    // A merchant-controlled selector can be invalid. Treat it like a missing
    // anchor so the inline surface remains absent instead of breaking the app.
    return null;
  }
  if (!referenceNode) return null;

  let position = "after";
  if (store.insertPositionBefore) position = "before";
  if (store.insertPositionPrepend) position = "prepend";
  if (store.insertPositionAppend) position = "append";
  return {referenceNode, position};
}


export function setupPlacement(store) {
  const placement = resolvePlacement(store);
  if (!placement) {
    store.setEl(null);
    return;
  }

  const { referenceNode, position } = placement;

  const el = document.createElement("div");
  el.className = "ov-app ov-app-prompt-inline";
  el.setAttribute("data-app", "prompt-inline");
  el.setAttribute("data-prompt-id", store.id);
  el.setAttribute("data-app-id", store.id);

  if (position === "before") {
    referenceNode.parentNode.insertBefore(el, referenceNode);
  } else if (position === "prepend") {
    referenceNode.insertBefore(el, referenceNode.firstChild);
  } else if (position === "append") {
    referenceNode.appendChild(el);
  } else {
    referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
  }

  store.setEl(el);
}


export function retryInsert(store, successTasks) {
  let stopped = false;
  let handle = null;

  const stop = (reportMissingAnchor = false) => {
    if (stopped) return;
    stopped = true;
    if (handle !== null) window.clearInterval(handle);

    if (
      reportMissingAnchor &&
      !store.rendered &&
      !store.el &&
      typeof console !== 'undefined' &&
      console.warn
    ) {
      console.warn(
        `[OnVoard] inline prompt anchor not found for ${store.id}: ${store.placementCssSelector}`
      );
    }
  };

  handle = window.setInterval(() => {
    if (stopped) return;
    store.incrPlacementInsertRetries();

    if (store.placementInsertRetries >= MAX_PLACEMENT_INSERT_RETRIES || store.rendered) {
      stop(store.placementInsertRetries >= MAX_PLACEMENT_INSERT_RETRIES && !store.rendered);
      return;
    }

    setupPlacement(store);
    if (store.el) {
      stop();
      successTasks();
      return;
    }
  }, 1000);

  return () => stop();
}
